import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Esto sirve si soy principiante?',
  a: 'Sí. Aunque fue diseñado pensando en profesionales activos, también puede ayudarte si estás formándote y querés desarrollar criterio técnico real más rápido.'
}, {
  q: '¿Funciona en Argentina?',
  a: 'Sí. El sistema fue pensado para profesionales de Argentina y puede aplicarse perfectamente en otros países de Latinoamérica.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No obligatoriamente, pero si ya trabajás con color vas a aprovechar muchísimo mejor el sistema.'
}, {
  q: '¿Es digital o físico?',
  a: 'Es 100% digital. Accedés en formato descargable inmediatamente después de tu compra.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Recibís acceso digital automático luego de completar tu pago.'
}, {
  q: '¿Qué métodos de pago aceptan?',
  a: 'Tarjetas, MercadoPago y medios compatibles según tu país.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés garantía total de 7 días. Si no es lo que esperabas, pedís devolución.'
}, {
  q: '¿Voy a poder aplicar esto rápido?',
  a: 'Sí. Justamente por eso incluimos la ruta express de implementación en 7 días.'
}, {
  q: '¿Las plantillas vienen listas para usar?',
  a: 'Sí. Son herramientas profesionales diseñadas para aplicación inmediata.'
}, {
  q: '¿El sistema premium realmente vale la diferencia?',
  a: 'Sí. Porque no solo aprendés teoría: incorporás criterio avanzado + herramientas listas para usar.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-brand-grayLight py-16 px-5" data-id="element-100">
      <div className="max-w-xl mx-auto" data-id="element-101">
        <h2 className="text-2xl md:text-3xl font-black text-center text-slate-900 mb-12" data-id="element-102">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-103">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white border border-slate-100 rounded-2xl overflow-hidden transition-all shadow-sm" data-id="element-104">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-slate-50 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-105">
                <span className="font-bold text-slate-800 text-base pr-6" data-id="element-106">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-[#C8A96B] flex-shrink-0" size={20} data-id="element-107" /> : <ChevronDown className="text-slate-300 flex-shrink-0" size={20} data-id="element-108" />}
              </button>
              {openIdx === idx && <div className="px-6 pb-6 text-sm md:text-base text-slate-500 leading-relaxed border-t border-slate-50" data-id="element-109">
                  <div className="pt-5" data-id="element-110">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}